import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpRequestQueuePage } from '@/features/pcmp/pages/PcmpRequestQueuePage';
import { pcmpRequestQueueSearchSchema } from '@/features/pcmp/types/pcmpRequest.types';

export const Route = createFileRoute('/_auth/pcmp/requests/')({
  validateSearch: pcmpRequestQueueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Requests">
      <Suspense fallback={<PageLoader />}>
        <PcmpRequestQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
